import React from "react";
import PropTypes from "prop-types";
import styles from "./variantDetails.scss";

const VariantDetails = (props) => {
  const {
    variant,
    variantIndex,
    selectedVariant,
    selectVariant,
    isValidVariant,
    isSelectedValue,
    getSelectedVariantValue,
  } = props;

  const getOptionClass = (value, valueIndex, className, disabled) => {
    return `${styles[className]} ${disabled ? styles["disabled"] : isValidVariant(variantIndex, value) ? (isSelectedValue ? isSelectedValue(variantIndex, valueIndex) : valueIndex === selectedVariant[variantIndex]) ? styles["active"] : "" : styles["disabled"]}`;
  };
  const renderVariantText = (variant, variantIndex, showValue) =>
    `${variant.name}${showValue ? `- ${getSelectedVariantValue(variantIndex).value || ""}` : ""
    }`;

  const renderDefaultVariantValue = (value, valueIndex) => {
    return (
      <label key={valueIndex} className={styles["labl"]}>
        <input
          type="radio"
          value={value.value}
          name="size_radio_btns"
          checked={selectedVariant[variantIndex] === valueIndex}
          onChange={() => selectVariant(variantIndex, valueIndex)}
          disabled={value?.disabled}
        />

        <div className={getOptionClass(value.value, valueIndex, "size_btn", value?.disabled)}>
          <span className={styles["size_btn_text"]}>
            {value.name || value.value}
          </span>
        </div>
      </label>
    );
  };
  const renderDefaultVariant = () => {
    return (
      <div className={styles["variant_container"]}>
        <span className={styles["variant_text"]}>{variant.name}</span>
        <div className={styles["sizes_options"]}>
          {variant.values.map(renderDefaultVariantValue)}
        </div>
      </div>
    );
  };

  switch (variant.code) {
    case "multi_dimension_color":
      return (
        <div className={styles["variant_container"]}>
          <span className={styles["variant_text"]}>
            {renderVariantText(variant, variantIndex, true)}
          </span>
          <div className={styles["shades_options"]}>
            {variant.values.map((value, valueIndex) => {
              if (value.displayOnlyText)
                return renderDefaultVariantValue(value, valueIndex);
              return (
                <div
                  key={valueIndex}
                  className={getOptionClass(
                    value.value,
                    valueIndex,
                    "select_circles"
                  )}
                >

                  {!isValidVariant(variantIndex, value.value) && (
                    <div className={styles["styles_bar"]}></div>
                  )}
                  <label className={styles["labl"]}>
                    <input
                      type="radio"
                      value={value.value}
                      name="shade_radio_btns"
                      // disabled={!isValidVariant(variantIndex, value.value)}
                      onChange={() => selectVariant(variantIndex, valueIndex)}
                    />
                    <div
                      className={styles["shade_btn"]}
                      style={{
                        backgroundImage: `url(${value.image})`,
                      }}
                    ></div>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      );

    case "multi_dimension_payment":
    case "multi_dimension_delivery":
    case "multi_dimension_warranty":
      return (
        <div className={styles["variant_container"]}>
          <span className={styles["variant_text_radio"]}>{variant.name}</span>
          <div className={styles["radio_options"]}>
            {variant.values.map((value, valueIndex) => (
              <div
                key={valueIndex}
                className={getOptionClass(
                  value.value,
                  valueIndex,
                  "select_radio"
                )}
              >

                <label className={styles["labl"]}>
                  <input
                    type="radio"
                    value={value.value}
                    name="radio_btns"
                    // disabled={!isValidVariant(variantIndex, value.value)}
                    onChange={() => selectVariant(variantIndex, valueIndex)}
                  />
                  <span className={styles["radio"]}></span>
                  <span className={styles["text"]}>{value.value}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      );

    default:
      return renderDefaultVariant();
  }
};

VariantDetails.defaultProps = {
  variant: null,
  variantIndex: 0,
  selectedVariant: [],
  selectVariant: () => { },
  isValidVariant: () => { },
  getSelectedVariantValue: () => { },
};

VariantDetails.propTypes = {
  variant: PropTypes.object.isRequired,
  variantIndex: PropTypes.number.isRequired,
  selectedVariant: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectVariant: PropTypes.func.isRequired,
  isValidVariant: PropTypes.func.isRequired,
  getSelectedVariantValue: PropTypes.func.isRequired,
};

export default VariantDetails;
